/*@flow*/
import type { Context } from './types';

const commands = (ctx: Context): {|
  close: (opts?: {confirm: boolean, ...}) => void,
  dupResource: (o: $Shape<{id: ID, resourceName: string, ...}>) => void,
  editResource: (o: $Shape<{id: ID, resourceName: string, ...}>) => void,
  newResource: (o: $Shape<{resource: any, resourceName: string, ...}>) => void,
  open: () => void,
  reset: () => void,
  selectResource: (name: string) => void,
  set: (path: string, value: any) => void,
  setResourceKey: (key: string, value: any) => void,
  showForm: () => void,
  startIntegration: () => void,
|} => ({
  reset() {
    ctx.dispatch({ type: 'RESET' });
  },
  selectResource(name: string) {
    ctx.dispatch({ type: 'SELECT_RESOURCE', payload: name });
  },
  showForm() {
    commands(ctx).set('mode', 'WIZARD_FORM');
  },
  editResource(o: $Shape<{ id: ID, resourceName: string }>) {
    ctx.dispatch({ type: 'EDIT_RESOURCE', payload: o });
  },
  dupResource(o: $Shape<{ id: ID, resourceName: string }>) {
    ctx.dispatch({ type: 'DUP_RESOURCE', payload: o });
  },
  setResourceKey(key: string, value: any) {
    commands(ctx).set(`resource.${key}`, value);
  },
  newResource(o: $Shape<{ resourceName: string, resource: Object }>) {
    ctx.dispatch({ type: 'NEW_RESOURCE', payload: o });
  },
  open() {
    ctx.dispatch({ type: 'OPEN_WIZARD' });
  },
  startIntegration() {
    ctx.dispatch({ type: 'START_INTEGRATION' });
  },
  close(opts?: { confirm: boolean }) {
    if (opts) {
      const msg = 'You have unsaved work. Do you want to close the form?';
      confirm(msg) && ctx.dispatch({ type: 'CLOSE_WIZARD' });
    } else {
      ctx.dispatch({ type: 'CLOSE_WIZARD' });
    }
  },
  set(path: string, value: any) {
    ctx.dispatch({
      type: 'SET_RECORD',
      payload: { path, value },
    });
  },
});

export default commands;
